module.exports = __webpack_public_path__ + "static/img/baas_chance_3.8a57dbe.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_chance_3.svg
// module id = H014
// module chunks = 0